// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_14DFP","logo":"index_logo_1Lr5I","logoAnimate":"index_logoAnimate_3i4GY","mainLogo":"index_mainLogo_BPYpQ","version":"index_version_Oa3f1"};